<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1IwdBU/tc-custom/9781512490077.jpg?1718163290919" alt="This image is the cover for the book It's Sukkah Time!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Sukkah Time!
      </h1>
      <p class="bookDescription body article font2">
        <p>A preschool class demonstrates the steps of sukkah-building to celebrate the fall harvest festival of Sukkot. Blessings in Hebrew and English are included.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Latifa Berry Kropf, Tod Cohen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?775bb9ba